const getDefaults = (title) => {
  const settings = {
    aspect_ratio: 2,
    fps: 15,
    frame_height: 2048,
    frame_length: 0,
    frame_offset: 0,
    frame_width: 4096,
    gutter: 10,
    ragged_gutter: 10,
    is_cards: false,
    line_height: 1.5,
    matte: "center",
    matte_alpha: "ff",
    matte_color: "#000000",
    page_break_inside_blocks: true,
    pixel_aspect_x: 1,
    pixel_aspect_y: 1,
    playback_fps: 23,
    ppf: 5,
    resolution: "4k",
    scale: 4,
    screen_height: 2160,
    screen_width: 4096,
    target_duration: 650,
    target_tolerance: 15,
    targeting_mode: "locked",
    title,
    title_safe_hd_crop: true,
    title_safe_height: 2048,
    title_safe_height_ratio: 0.8,
    title_safe_width: 3072,
    title_safe_width_ratio: 0.8,
    variant: "",
  };

  const fontStyle = {
    blurb: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
    heading: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
    logo: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
    name: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
    role: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
    songDetails: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
    songTitle: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
    subHeading: {
      color: "#ffffff",
      fontFamily: "Roboto",
      fontSize: 15,
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "none",
      lineHeight: "1",
      textDecoration: "none",
    },
  };
  const commonOptions = {
    double_columns: false,
    balance_columns: null,
    bullets: null,
    block_inset: "default",
    block_name: "",
    column_flow: "horizontal",
    column_order: null,
    column_width: 100,
    columns: 1,
    heading: "",
    subheading: "",
    name_on_left: false,
    side_by_side: "off",
    text_alignment: "center",
    extra_lines_below: 0,
    horizontal_gap: 0,
    margin_vertical: 10,
    gap: 30,
    gapHorizontal: 30,
    gapVertical: 0,
    // ragged_gutter: 10,
    spacing: 0,
  };
  const options = {
    blurb: {
      block_type: "blurb",
      ...commonOptions,
    },
    image: {
      block_type: "image",
      ...commonOptions,
    },
    logo: {
      block_type: "logo",
      ...commonOptions,
    },
    nameonly: {
      ...commonOptions,
      block_type: "nameonly",
      columns: 2,
    },
    rolename: {
      ...commonOptions,
      block_type: "rolename",
      double_columns: true,
      text_alignment: "gutter",
      spacing: 12,
    },
    song: {
      block_type: "song",
      ...commonOptions,
      columns: 2,
    },
  };
  return { settings, fontStyle, options };
};

const getBlockType = (row, currentBlockType) => {
  if (row.length === 0) return currentBlockType;
  if (row[0]) return "newBlock";
  if (row[1]) return "rolename";
  if (row[2]) {
    return currentBlockType === "rolename" ? "rolename" : "nameonly";
  }
  if (row[3]) return "logo";
  if (row[5]) return "song";
  if (row[6]) return "song";
  if (row[4]) return "blurb";
  return currentBlockType;
};

const getBlockItem = (row) => {
  let item = {};
  if (row[1]) item["role"] = row[1];
  if (row[2]) item["name"] = row[2];
  if (row[3])
    item["logo"] = {
      ...defaultLogoItem,
      title: row[3],
    };
  if (row[4]) item["blurb"] = row[4];
  if (row[5]) {
    if (!item.song) {
      item["song"] = {};
    }
    item["song"]["title"] = row[5];
  }
  if (row[6]) {
    if (!item.song) {
      item["song"] = {};
    }
    item["song"]["details"] = row[6];
  }
  return item;
};

const defaultLogoItem = {
  thumbnail: "",
  url: "",
  scale: 80,
  title: "",
  offset_x: 0,
  offset_y: 0,
};

const excelDataToCredits = (creditsArray) => {
  let lastCellIdx = -1;
  for (let i = creditsArray.length - 1; i > 0; i--) {
    if (creditsArray[i].length) break;
    lastCellIdx = i;
  }

  if (lastCellIdx != -1) creditsArray.splice(lastCellIdx);

  const { options } = getDefaults();

  let credits = [];
  let blockName;
  let blockType;
  let items = [];

  const insertBlock = () => {
    let block = {};
    if (blockType) {
      const defaultOptions = { ...options[blockType] };
      defaultOptions["block_name"] = blockName;
      block["options"] = defaultOptions;
      block["items"] = items;
      credits.push(block);
    }
  };

  const resetDefaults = (row) => {
    blockName = row[0];
    blockType = getBlockType(row, blockType);
    items = [];
  };

  for (let i = 1; i < creditsArray.length; i++) {
    let row = creditsArray[i];
    if (getBlockType(row, blockType) === "newBlock") {
      insertBlock();
      resetDefaults(row);
    } else {
      blockType = getBlockType(row, blockType);
      let item = getBlockItem(row);
      items.push(item);
      item = {};
    }
    if (i === creditsArray.length - 1) {
      insertBlock();
    }
  }

  credits = credits.map((credit) => {
    if (credit.options.block_type !== "logo") return credit;
    let items = credit.items;
    if (items.length > 5) items.splice(5);
    for (let i = 0; i < 5; i++) {
      if (i < items.length)
        items[i].logo = { ...items[i].logo, row: 0, position: i };
      else items.push({ logo: { ...defaultLogoItem, row: 0, position: i } });
    }
    return { items, options: credit.options };
  });
  return credits;
};

const excelDataToProjectData = (title, creditsArray) => {
  let { settings, fontStyle } = getDefaults(title);
  let project = {
    title,
    settings,
    fontStyle,
  };

  // ['block_name', 'role', 'name', 'logo', 'blurb', 'song_title', 'song_details', 'COMMENTS']
  project.credits = excelDataToCredits(creditsArray);
  return project;
};

export { excelDataToProjectData, excelDataToCredits, defaultLogoItem };
